export const buildRoutingPrefix = "build";
export const plgCRMRoutingPrefix = "analyze";
export const driveRoutingPrefix = "drive";
export const onBoardingRoutingPrefix = "on-boarding";
export const invitationSimulationPrefix = "simulation/invitation";
export const workflowRoutingPrefix = "workflow";
export const signupBuilderRoutingPrefix = "signup-builder";
